import React from "react";

// @ts-ignore
import Flag from 'react-world-flags'

import './delivery.scss';

export const getFlag = ({ code, width, height, source, marginRight, marginTop }: CalculatorFlagProps) => {

  const imageStyle = {
    width: width || '32px',
    height,
    boxSizing: 'content-box' as const,
    maxHeight: '24px',
  };

  return <div
    className='general-flag'
    style={{
      marginRight: marginRight || '10px',
      marginTop: marginTop || 0,
    }}
  >
    {source ? <img src={source} alt={code || ''} style={imageStyle} /> : <Flag
      code={code || ''}
      style={imageStyle}
      svg='true'
    />}
  </div>
}
